export default {
  'administration.title': 'Administración',
  'administration.copyProcess': 'Copiar Proceso',
  'administration.newProcess': 'Nombre del Nuevo Proceso',
  'administration.copyProcess.description':
    'Copiar proceso y todas sus configuraciones. Será copiado además, en caso de ser necesario las entidades relacionadas(Formularios, Campos, Formatos, Entidades Relacionadas,...)',
};
